/* @flow strict */

class SSRWarning extends Error {
  name = 'SSRWarning';
}

export default SSRWarning;
